import { h, render } from "preact";
import register from "preact-custom-element";
import ProductOptions from "./product-options/product-options";
import {
  unavailableStockStatuses,
  productOptionSizes,
  productOptionSwatchStyles,
} from "./product-options/product-option-styles";
import { collectionFilterFromSearch } from "../helpers/collectionFilter";

function ProductFormOptions({
  productId,
  idPrefix,
  initialVariantId,
  initialVariantHidden,
  initialFirstOptionValue,
  optionsRole,
  enableSwatchPreview,
  enableAccordions,
  quantityRequested,
  enableAvailabilityPreview,
  optionSize,
  disabledSwatchStyle,
  layout,
  collectionFilter,
  collectionFilterFromUrl,
}) {
  return (
    <ProductOptions
      productId={productId}
      idPrefix={idPrefix}
      initialVariantId={initialVariantId}
      initialVariantHidden={initialVariantHidden !== undefined}
      initialFirstOptionValue={initialFirstOptionValue}
      optionsRole={optionsRole}
      enableSwatchPreview={enableSwatchPreview !== undefined}
      enableAccordions={enableAccordions !== undefined}
      quantityRequested={quantityRequested}
      enableAvailabilityPreview={enableAvailabilityPreview !== undefined}
      optionSize={optionSize || productOptionSizes.default}
      disabledSwatchStyle={
        disabledSwatchStyle || productOptionSwatchStyles.default
      }
      unavailableStockStatuses={unavailableStockStatuses.waitlist}
      waitlistStockStatuses={unavailableStockStatuses.waitlist}
      layout={layout}
      collectionFilter={
        collectionFilter ||
        (collectionFilterFromUrl !== undefined
          ? collectionFilterFromSearch(window.location.search)
          : null)
      }
    />
  );
}

if (!customElements.get("product-form-options")) {
  register(
    ProductFormOptions,
    "product-form-options",
    [
      "product-id",
      "id-prefix",
      "initial-variant-id",
      "initial-variant-hidden",
      "initial-first-option-value",
      "options-role",
      "enable-swatch-preview",
      "enable-accordions",
      "quantity-requested",
      "enable-availability-preview",
      "option-size",
      "disabled-swatch-style",
      "layout",
      "collection-filter",
      "collection-filter-from-url",
    ],
    {
      shadow: false,
    },
  );
}
